import React, { Component } from "react";
import Banner from "./Banner";
import HowItWorks from "./HowItWorks";
import KeyEnablers from "./KeyEnablers";
import ProjectsBy from "./ProjectsBy";
// import Feedback from "./Feedback";
import { Message } from "./OurMinisters/Message";
import LatestNews from "./LatestNews";
import FAQs from "./FAQs";
import { PATHS } from "../../constant";
import { connect } from "react-redux";
import KeyEnablersResponsive from "./keyEnablers.responsive";
import { CoronAdv } from "../advertisment";
import HowItWorksResponsive from "./HowItWorksResponsive";
import BannerResponsive from "./BannerResponsive";
// import SecuredKeyClock from "../authentication/SecuredKeyClock";
import { withCookies } from "react-cookie";
import OurMinistersSlider from "./OurMinisters/OurMinistersSlider";
import LatestArticles from "./LatestArticles";

class Front extends Component {
  componentDidMount() {
    const { history } = this.props;
    if (localStorage && localStorage.getItem("token")) {
      history.push(PATHS.DASHBOARD);
    }
  }

  render() {
    let { cookies, isDesktopView } = this.props;

    return (
      <div className="front-page-inner">
        {/* <SecuredKeyClock cookies={cookies} onLoad="check-sso" /> */}
        {isDesktopView ? <Banner /> : <BannerResponsive />}
        <CoronAdv isDesktopView={isDesktopView} />
        <HowItWorksResponsive isDesktopView={isDesktopView} />
        {isDesktopView ? <KeyEnablers /> : <KeyEnablersResponsive />}
        <ProjectsBy isDesktopView={isDesktopView} />
        {/* <NewsAndBlogs /> */}
        {/*<Feedback />*/}
        <LatestArticles />
        {isDesktopView ? <Message /> : <OurMinistersSlider />}
        <LatestNews isDesktopView={isDesktopView} />
        <FAQs />
      </div>
    );
  }
}

const mapStateToProps = state => ({
  isDesktopView: state.commonReducer.isDesktopView
});

export default connect(
  mapStateToProps,
  null
)(withCookies(Front));
